import * as api from './index';
const settings = '/company/settings';
const users = '/company/users';

export default {
  get: api.get(settings),
  update: api.post(settings),

  userSearch: api.get(`${users}/search`),
};